import { render } from "./ConfirmWithNotesModal.vue?vue&type=template&id=20865b2a"
import script from "./ConfirmWithNotesModal.vue?vue&type=script&lang=js"
export * from "./ConfirmWithNotesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__